import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { BackendService } from 'src/app/core/services/backend-prod.service';
import { HelperService } from 'src/app/core/services/helper.service';
import { Storage } from '@ionic/storage';
import { MenuService } from 'src/app/core/services/menu.service';

@Component({
  selector: 'app-update-views-update',
  templateUrl: './update-views-update.component.html',
  styleUrls: ['./update-views-update.component.scss'],
})
export class UpdateViewsUpdateComponent implements OnInit {
  name = 'ng2-ckeditor';
  ckeConfig: any;
  // mycontent: string = 'this is home';
  log: string = '';
  @ViewChild("myckeditor") ckeditor: any;
  ckEditorConfig: any = {
    toolbar: [
      ['Source', 'Templates', 'Bold', 'Italic', 'Underline', 'Strike', 'Subscript', 'Superscript', '-', 'CopyFormatting', 'RemoveFormat'],
      ['Cut', 'Copy', 'Paste', 'PasteText', 'PasteFromWord', '-', 'Undo', 'Redo'],
      ['Find', 'Replace', '-', 'SelectAll', '-'],
      ['Link', 'Unlink'],
    ],
    allowedContent: true,
    versionCheck: false
  };
  breadcrumbList = [
    {
      label: 'Product Updates',
      url: '/baseapp/product-updates'
    },
    {
      label: 'Update',
      url: '/baseapp/product-updates/updateview'
    }
  ];
  addUpateViewsForm: UntypedFormGroup;
  // submitted: boolean = false;
  hide: boolean = true;
  hide1200: boolean = false;
  userIp;
  userPermissionList = [];
  selectedPermissionArr = [];
  block = [
    {
      label: 'Yes',
      value: true
    },
    {
      label: 'No',
      value: false
    }
  ]
  userViewObj;
  userId: string = ''

  constructor(
    private formBuilder: UntypedFormBuilder,
    public breakpointObserver: BreakpointObserver,
    private backendService: BackendService,
    private router: Router,
    public storage: Storage,
    private menuService: MenuService,
    public helperService: HelperService,
    private route: ActivatedRoute) { }

  ngOnInit() {
    this.addUpateViewsForm = this.formBuilder.group({
      'eventName': ['', Validators.required],
      'description': ['', Validators.required],
    });
    const user_id = this.route.snapshot.params['id'];
    this.getUserIp(user_id);
    // this.getUserDetails(user_id)
    this.breakpointObserver.observe(['(min-width: 1200px)']).subscribe((state: BreakpointState) => {
      if (state.matches) {
        this.hide1200 = true;
      } else {
        this.hide1200 = false;
      }
    });
  }


  getUserDetails(user_id) {
    this.helperService.loader();
    this.getStorage().then((res) => {
      let payload = {
        id: user_id
      }
      this.backendService.PostAPICall('getViewById', payload, res.token).subscribe(
        (data) => {
          let res = data.data[0];
          this.userViewObj = res;
          //console.log(this.userViewObj.description)
          this.addUpateViewsForm.patchValue({
            eventName: this.userViewObj.event_name,
            description: this.userViewObj.description,
          })
          this.userId = user_id;
          this.helperService.closeLoader();
        },
        (error) => {
          //console.log(error);
          this.helperService.handleError(error);
              this.helperService.closeLoader();
        }
      );
    })
  }

  onEditorChange(event) {
    //console.log(event);
  }

  onChange(event: any): void {
    //console.log(event);
    //this.log += new Date() + "<br />";
  }

  async getStorage() {
    let data = {
      token: await this.storage.get("token"),
      userId: await this.storage.get("id")
    }
    return data;
  }

  getUserIp(user_id) {
    this.backendService.getUserIp().subscribe(
      (data) => {
        const e: any = data as any;
        //console.log(e);
        this.userIp = e.ip;
        this.getUserDetails(user_id)
      })
  }


  onSubmit() {
    // this.submitted = true;
    if (this.addUpateViewsForm.invalid) {
      this.helperService.presentToast("Form incomplete", 2000);
      return;
    }
    this.helperService.loader();
    this.getStorage().then((res) => {
      let payload = {
        id: this.userId,
        event_name: this.addUpateViewsForm.value.eventName,
        description: this.addUpateViewsForm.value.description,
        ip_address_created: this.userIp,
      }

      this.backendService.PostAPICall('updateView', payload, res.token).subscribe(
        (data) => {
          // this.submitted = false;
          this.helperService.closeLoader();
          this.helperService.presentToast(data.msg, 2000);
          this.router.navigate(['/baseapp/product-updates']);
        },
        (error) => {
          //console.log(error);
          // this.submitted = false
          this.helperService.handleError(error);
              this.helperService.closeLoader();
        }
      );
    })
  }

}

